/**
 * @fileoverview A function that debounces a function.
 *
 * @example
 * const debouncedFunction = debounce(originalFunction, 300)
 */

/**
 * @function debounce
 * @description Debounces a function.
 * @param {Function} fn - The function to debounce.
 * @param {number} ms - The delay in milliseconds.
 * @returns {Function} - The debounced function.
 */
export function debounce(fn: (...args: unknown[]) => unknown, ms = 300) {
    let timeoutId: ReturnType<typeof setTimeout>
    return function (this: unknown, ...args: unknown[]) {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => fn.apply(this, args), ms)
    }
}
